<script>
  import { External, M } from '../../external';
  import { onMount } from 'svelte';
  import { millisecondsToTimestamp } from '../../Common/tools';
  import { loadPlayerScripts } from '../static';

  export let video;
  export let timestamp = {};
  let plyrPreview = null;
  let targetFrameStr = null;

  let loadPlyrPreview = (videoHolder) => {
    if (video) {
      loadPlayerScripts(() => {
        plyrPreview = new window.Plyr(videoHolder, {
          controls: false,
          settings: [],
          clickToPlay: false,
          fullscreen: {
            enabled: false
          }
        });
        if (window.Hls.isSupported()) {
          let hslConfig = {
            //length in seconds
            maxBufferLength: 9,
            //length in seconds
            maxMaxBufferLength: 12,
            //size in bytes
            maxBufferSize: 20 * 1000 * 1000,
          };
          let hls = new window.Hls(hslConfig);
          hls.loadSource(video.videoPath);
          hls.attachMedia(videoHolder);
        }

        plyrPreview.on('ready', () => {
          plyrPreview.muted = true;
          plyrPreview.volume = 0;
        });
        plyrPreview.on('loadeddata', () => {
          plyrPreview.currentTime = timestamp.time / 1000;
        });
      });
    }
    return {
      destroy: () => {
        if (plyrPreview) {
          plyrPreview.destroy();
          plyrPreview = null;
        }
      }
    };
  };

  //triggered when slider for video loop as a thumb is shown
  let loadPlyrPreviewSlider = (node) => {
    let sliderHolder = {
      min: 0,
      max: video.durationInMs,
      value: timestamp.time,
      element: External.$(node)
    };
    External.Tools.addSlider(sliderHolder);
    sliderHolder.element.on('slide', function(event, ui) {
      plyrPreview.currentTime = ui.value / 1000;
      targetFrameStr = millisecondsToTimestamp(ui.value);
    });
    sliderHolder.element.on('slidestop', function(event, ui) {
      timestamp.time = ui.value;
      plyrPreview.currentTime = ui.value / 1000;
    });
    return {
      destroy: () => {
        sliderHolder.element.slider('destroy');
      }
    };
  };

  onMount(() => {
    targetFrameStr = millisecondsToTimestamp(timestamp.time);
  });

  export const getResult = () => {
    return timestamp;
  };
</script>
<div class="popup-widget-wrapper">
  <div class="col20 f-left small-rules mb-15">
    <div class="popup-input-wrapper f-left mt-15">
      {#if video}
        <div class="popup-input-wrapper mt-15 mb-15">
          <video crossorigin playsinline use:loadPlyrPreview></video>
        </div>
        <div use:loadPlyrPreviewSlider></div>
        {targetFrameStr}
      {/if}
    </div>
  </div>
</div>

